import { Box, Typography } from '@mui/material'
import React from 'react'
import type { PropertyType } from '@/object-types/gql/PropertyType'
import { propertyFormConfig } from './PropertyFormConfig.tsx'
import type { PropertyDefinitionModel } from '@/core/gql/gql-models-override.ts'
import { iconForType } from '@/objects/property-forms/property-forms-shared.tsx'

const config = propertyFormConfig
interface PropertyNameProps {
  propDef: PropertyDefinitionModel
  widthPx: number
}

export function PropertyName({ propDef, widthPx }: PropertyNameProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      {iconForType(propDef.type)}
      <Typography
        noWrap
        sx={{
          width: `${widthPx}px`,
          fontSize: '0.875rem',
          alignItems: 'center',
          textAlign: 'left',
          px: 1.5,
          color: (theme) => theme.palette.grey[600],
        }}
      >
        {propDef.name}
      </Typography>
    </Box>
  )
}
